import { ThemeProvider } from "@ligo/layout-design-core";
import { AuthProvider, ProfileProvider } from "providers";
import GlobalStyle from "./global.styles";
import RoutesMap from "./routes";

const App = () => {
  return (
    <ThemeProvider toastConfig={{ $position: "bottom-right" }}>
      <AuthProvider>
        <ProfileProvider>
          <RoutesMap />
          <GlobalStyle />
        </ProfileProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
